import {Component, Input, OnInit} from '@angular/core';
import {Flow} from '../../shared/constants';
import {GlobalQuestionService} from '../../shared/services/global-question.service';
import {FlowPlayerService} from '../../shared/services/flow-player.service';
import {ClaimStore} from '../state/state/claims-session.store';
import {QuestionFlowSessionQuery} from '../../shared/questions/state/question-flow-session.query';
import { Policy } from '../../shared/models/policy.model';
import { PolicyStore } from '../../policy/state/policy.store';
import { PolicyQuery } from '../../policy/state/policy.query';
import { UserStore } from '../../authentication/state/user.store';

declare const $: any;

@Component({
    selector: 'app-emergency-services-modal',
    templateUrl: './emergency-services-modal.component.html',
    styleUrls: ['./emergency-services-modal.component.scss'],
    standalone: false
})
export class EmergencyServicesModalComponent implements OnInit {

  @Input() active: boolean = false;
  policy: any;
  user: any;
  // Result of the getClaimsSuperflow call the opening page already made through
  // ClaimGuardService. Every showModal() call site sits inside that guard's
  // subscribe, so re-running the guard here would call the proc a second time —
  // and getClaimsSuperflow WRITES when policy_id is set (it EXECs createClaim),
  // so the second call trips its own initiated-claim guard on the claim the
  // first call just created.
  private guardResult: any;
  constructor(
    private questionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private claimStore: ClaimStore,
    private policyQuery: PolicyQuery,
    private userStore: UserStore,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
  ) {
    this.user = this.userStore.getValue();
  }

  ngOnInit(): void {

  }

  showModal(guardResult: any = null): void {
    this.guardResult = guardResult;
    if (this.active) {
      const policy = this.policyQuery.getActive();
      let tempPolicy: Policy;
      if (Array.isArray(policy)) {
        tempPolicy = Object.assign({}, policy[0]);
      } else {
        tempPolicy = Object.assign({}, policy);
      }
      this.policy = tempPolicy;
    }
    console.log(this.policy)
    $('#emergency-services-modal').modal('show');
  }

  createClaim(is_emergency: boolean): void {
    const result = this.guardResult;
    if (!result?.length || !result[0]?.next_superflow) {
      return;
    }
    this.claimStore.reset();
    if (this.user.broker_id > 0 || this.user.console_access){
      if (this.policy && this.policy.person?.[0]) {
        localStorage.setItem("context_person_id",this.policy.person[0].person_id);
        localStorage.setItem("context_person_first_name",this.policy.person[0].first_name);
      }
    }
    this.flowPlayer.startSuperFlow(result[0]?.next_superflow, 0, (is_emergency ? 0 : Flow.Claim_Emergency), 0, '0', result[0]?.session_id, '');
    setTimeout(() => {
      if (is_emergency) {
        const sessionDetails = this.questionFlowSessionQuery.getValue();
        if (sessionDetails?.session_id) {
          this.questionService.saveAnswer(sessionDetails.session_id, 1073, 0, '0', '8', 0, '').subscribe();
        }
      }
    }, 3000);
  }

}
